// Prints a list as a plain bordered table (Word-like) in its own window, so
// none of the app's styling/layout ends up on paper. Used by the "Print"
// button on the list pages -- callers pass the already filtered rows.
//
// columns: [{ header: 'Name', align: 'right' }]  (align optional)
// rows:    [['cell', 'cell', ...], ...]          (one array per row)

const esc = (v) =>
  String(v ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const cell = (tag, value, align) =>
  `<${tag}${align === 'right' ? ' class="num"' : ''}>${esc(
    value === null || value === undefined || value === '' ? '-' : value,
  )}</${tag}>`;

export const printTable = ({ title, subtitle, columns, rows }) => {
  const win = window.open('', '_blank');
  if (!win) return;

  const head = columns.map((c) => cell('th', c.header, c.align)).join('');
  const body = rows
    .map(
      (row) =>
        `<tr>${row.map((v, i) => cell('td', v, columns[i]?.align)).join('')}</tr>`,
    )
    .join('');

  const info = [new Date().toLocaleDateString('de-CH'), subtitle, rows.length]
    .filter((x) => x !== undefined && x !== null && x !== '')
    .join(' · ');

  win.document.write(`<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>${esc(title)}</title>
<style>
  body { font-family: Calibri, Arial, sans-serif; font-size: 10pt; color: #000; margin: 20px; }
  h1 { font-size: 14pt; margin: 0 0 4px; }
  p { margin: 0 0 12px; font-size: 9pt; }
  table { border-collapse: collapse; width: 100%; }
  th, td { border: 1px solid #000; padding: 3px 5px; text-align: left; vertical-align: top; }
  th { font-weight: bold; }
  .num { text-align: right; white-space: nowrap; }
  tr { page-break-inside: avoid; }
  thead { display: table-header-group; }
  @page { margin: 12mm; }
</style>
</head>
<body>
<h1>${esc(title)}</h1>
<p>${esc(info)}</p>
<table>
  <thead><tr>${head}</tr></thead>
  <tbody>${body}</tbody>
</table>
</body>
</html>`);
  win.document.close();
  win.focus();
  win.print();
};

export default printTable;
